export class LigneCommande {
  quantite: number;
  prix: number;
  total: number;
  referenceLPC: string;
  titreOffre: string;
  libelleLicence: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/models/ligne-commande.model.ts